/**
 * Formata um número de telefone brasileiro para exibição.
 *
 * Aceita o formato do WhatsApp/E.164 (com ou sem "+", com ou sem o sufixo do JID),
 * e devolve no padrão do design: "+DDI DDD PREFIXO-LINHA".
 *
 *   "553191864770"               -> "+55 31 9186-4770"
 *   "5554999999999"              -> "+55 54 99999-9999"
 *   "553191864770@s.whatsapp.net"-> "+55 31 9186-4770"
 *
 * Espera DDI(2) + DDD(2) + parte local (8 ou 9 dígitos). Fora desse formato,
 * cai no fallback "+<dígitos>" (nunca lança).
 */
export const formatPhone = (raw?: string | null): string => {
  if (!raw) return "";

  // Remove o sufixo do JID ("@s.whatsapp.net", "@g.us") e tudo que não é dígito.
  const digits = String(raw).split("@")[0].replace(/\D/g, "");
  if (!digits) return "";

  const match = digits.match(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/);
  if (!match) return `+${digits}`;

  const [, country, area, prefix, line] = match;
  return `+${country} ${area} ${prefix}-${line}`;
};
